import { useState, useEffect } from "react";
import { isMobile } from "react-device-detect";

const useIsMobile = () => {
  const [checkIsMobile, setCheckIsMobile] = useState(isMobile);

  useEffect(() => {
    const handleResize = () => {
      setCheckIsMobile(window.innerWidth <= 768); // equal to md brakpoint of tailwind
    };

    // Initial check
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return checkIsMobile;
};

export default useIsMobile;
